import { render, staticRenderFns } from "./PollsStatistics.vue?vue&type=template&id=5a79d412&scoped=true&"
import script from "./PollsStatistics.vue?vue&type=script&lang=js&"
export * from "./PollsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./PollsStatistics.vue?vue&type=style&index=0&id=5a79d412&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a79d412",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VProgressCircular,VRow})
